export const featuresData = [
    {
        title: 'Improving expertise today',
        text: "Combining this expertise with our commitment to delivering cutting-edge products on time, we're revolutionizing the industry.",
    },
    {
        title: 'Become the future with us',
        text: "Shape your destiny and be at the forefront of progress. With us, you'll have the opportunity to become a leader in your industry and make a lasting impact.",
    },
    {
        title: 'Have a lasting impact',
        text: "At our core, we believe that great solutions stem from great ideas. Join our team in this quest for excellence and be part of a brighter future.",
    },
    {
        title: 'Our clients, our allies',
        text: 'Our clients trust us to deliver cutting-edge solutions that are both innovative and timely. Our commitment to excellence starts with valuing education.',
    },
]
